import { useEffect, useState } from "react";
import FilterReportAge from "./FilterReportAge";
import FilterReportCategories from "./FilterReportCategories";
import FilterReportPublishDate from "./FilterReportPublishDate";
import FilterReportUserChoose from "./FilterReportUserChoose";
import axios from "axios";
import { get_chart_reports_traffic } from "../../api/api";
import { removeEmptyObject } from "../../services/help";
import { toast } from "react-toastify";
import FilterReportSecoundCategories from "./FilterReportSecoundCategories";
import TitleBarReportChartPage from "./TitleBarReportChartPage";

const ComparisonBoxFilter = ({ isAdmin, queries, baseFilterValues, chartValues, setData, setDataChart }) => {

    const [filterVals, setFilterVals] = useState(chartValues > 0 ? chartValues : baseFilterValues)

    const [titleFilters, setTitleFilters] = useState()
    const [titleSort, setTitleSort] = useState()
    const [chartFilters, setChartFilters] = useState()

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setTitleFilters({})
        setChartFilters({})
        setTitleSort({})
    }, [])

    useEffect(() => {
        if (chartValues && chartValues !== undefined) {
            setFilterVals(chartValues)
        } else {
            setFilterVals(baseFilterValues)
        }
    }, [chartValues])



    const getChart = async () => {
        try {
            setIsLoading(true)
            const body = {
                ...Object(queries),
                filters: [
                    chartValues ? removeEmptyObject({
                        filterUserId: chartValues?.filterUserId?.value,
                        primarySubjectCategoryId: chartValues?.primarySubjectCategoryId?.value,
                        secondarySubjectCategoryId: chartValues?.secondarySubjectCategoryId?.value,
                        productionYear: chartValues?.publishDate?.value,
                        ages: chartValues?.ages?.value
                    }) : removeEmptyObject({
                        filterUserId: filterVals?.filterUserId?.value,
                        primarySubjectCategoryId: filterVals?.primarySubjectCategoryId?.value,
                        secondarySubjectCategoryId: filterVals?.secondarySubjectCategoryId?.value,
                        productionYear: filterVals?.publishDate?.value,
                        ages: filterVals?.ages?.value
                    }),
                    removeEmptyObject({
                        filterUserId: baseFilterValues?.filterUserId?.value,
                        primarySubjectCategoryId: baseFilterValues?.primarySubjectCategoryId?.value,
                        secondarySubjectCategoryId: baseFilterValues?.secondarySubjectCategoryId?.value,
                        productionYear: baseFilterValues?.publishDate?.value,
                        ages: baseFilterValues?.ages?.value
                    })
                ]
            }

            const res = await axios.post(get_chart_reports_traffic, body)
            setDataChart(res.data)
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }


    const handleSubmitChartBtn = async () => {

        if (baseFilterValues && Object.values(baseFilterValues)?.filter(e => e !== "").length > 0 &&
            Object.values(filterVals)?.filter(e => e !== "").length > 0) {


            setTitleFilters(baseFilterValues)
            setChartFilters(filterVals)

            setTitleSort(removeEmptyObject({
                regDateFrom: queries?.regDateFrom,
                regDateTo: queries?.regDateTo,
                sortType: queries?.sortType,
                dateType: queries?.dateType,
            }))

            getChart()
            // if (baseFilterValues.filterUserId && chartValues.filterUserId && filterVals.filterUserId) {
            //     getChart()
            // } else {
            //     toast.error('فیلتر کاربر نباید خالی باشد!')
            // }

        } else {
            toast.error('جهت رسم نمودار میبایست فیلتر ست کنید.')
        }

    }


    return (
        <>

            <style>{`#theChart .loading.mini{display:${isLoading ? 'block' : 'none'}}#theChart .zst4td{display:${isLoading ? 'none' : 'block'}}`}</style>

            <div className='fh'>
                <div className='filterItems'>
                    <span className="ttt">
                        <button type="button" disabled={isLoading} style={{ width: '173px', height: '38px', padding: '20px', lineHeight: 0, background: '#95a3b3', border: 'none' }} onClick={handleSubmitChartBtn}>
                            {isLoading ? 'لطفا صبر کنید...' : 'رسم نمودار'}
                        </button>
                    </span>


                    {isAdmin && <FilterReportUserChoose queries={queries} setData={setData} active={filterVals} mode={true} chartActive={chartValues} />}

                    <FilterReportPublishDate queries={queries} setData={setData} active={filterVals} mode={true} chartActive={chartValues} />
                    <FilterReportAge queries={queries} setData={setData} active={filterVals} mode={true} chartActive={chartValues} />
                    <FilterReportCategories queries={queries} setData={setData} active={filterVals} mode={true} chartActive={chartValues} />
                    <FilterReportSecoundCategories queries={queries} setData={setData} active={filterVals} mode={true} chartActive={chartValues} />

                </div>
            </div>

            <TitleBarReportChartPage filters={titleFilters} chartFilters={chartFilters} sort={titleSort} />

        </>
    );
}

export default ComparisonBoxFilter;